export const CARTON_TYPE = 'Paper box';
export const PALLET_TYPE = 'Pallet';
export const OBJECT_TYPE = 'Other';
export const COLLECTION_TYPE = 'Collection';
